export default document.documentElement.lang;
